<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<meta charset="utf-8"/>
<link href="styles/custom.css" rel="stylesheet" type="text/css"/>
<title>Blood Before Dawn</title>
<section epub:type="contributors">
<p class="ser"><span epub:type="pagebreak" id="page_vii" title="vii"><img alt="image" src="images/p7.jpg"/></span></p>
<p class="ser"><span epub:type="pagebreak" id="page_viii" title="viii"><img alt="image" src="images/p8.jpg"/></span></p>
<p class="ser"><span epub:type="pagebreak" id="page_ix" title="ix"><img alt="image" src="images/p9.jpg"/></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter02.vue?32a2248e